import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from "web-vitals";
import * as Sentry from "@sentry/react";
import { scrubTelemetryValue } from "./scrub.js";

function reportMetric(metric: Metric): void {
  const payload = scrubTelemetryValue({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
  });

  if (import.meta.env.DEV || !import.meta.env.VITE_SENTRY_DSN) {
    console.info("[web-vital]", payload);
  }

  Sentry.addBreadcrumb({
    category: "web-vital",
    message: metric.name,
    level: "info",
    data: payload,
  });

  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.metrics.distribution(`web_vital.${metric.name.toLowerCase()}`, metric.value, {
      unit: metric.name === "CLS" ? "none" : "millisecond",
      attributes: { rating: metric.rating },
    });
  }
}

export function startWebVitals(): void {
  onCLS(reportMetric);
  onINP(reportMetric);
  onLCP(reportMetric);
  onFCP(reportMetric);
  onTTFB(reportMetric);
}
